import { NavLink } from "react-router-dom";
import { navigationConfig } from "./navConfig";
import { NavItems } from "./NavItems";
import { SidebarFooter } from "./SidebarFooter";

export function Sidebar() {
	return (
		<aside
			aria-label="Main navigation"
			className="hidden xl:flex xl:w-[280px] xl:flex-col xl:fixed xl:inset-y-0 xl:left-0 xl:border-r xl:border-border xl:bg-background"
		>
			{/* Logo */}
			<div className="flex h-16 items-center px-6">
				<NavLink to="/admin" className="flex items-center">
					<img src="/mee-logo.svg" alt="Mee" className="h-6" />
				</NavLink>
			</div>

			{/* Navigation */}
			<div className="flex-1 overflow-y-auto px-4 py-4">
				<NavItems items={navigationConfig} />
			</div>

			<SidebarFooter />
		</aside>
	);
}
